import { render, staticRenderFns } from "./normal.vue?vue&type=template&id=1c11ec2e&scoped=true"
import script from "./normal.vue?vue&type=script&lang=js"
export * from "./normal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c11ec2e",
  null
  
)

export default component.exports